import { useSyncMomentShadowFlag } from './flag-source';

export function MomentShadowFlagSync(): null {
  useSyncMomentShadowFlag();
  return null;
}
